import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Home from "@pages/Home";
import PreviewPage from "@pages/PreviewPage";
import Dashboard from "@pages/Dashboard";
import MyFiles from "@pages/MyFiles";
import SharedLinks from "@pages/SharedLinks";
import UploadHistoryPage from "@pages/UploadHistory";
import Account from "@pages/Account";
import PublicDownload from "@pages/PublicDownload";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/preview", element: <PreviewPage /> },
      { path: "/account", element: <Account /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/files", element: <MyFiles /> },
          { path: "/links", element: <SharedLinks /> },
          { path: "/history", element: <UploadHistoryPage /> },
        ],
      },
    ],
  },
  { path: "/s/:token", element: <PublicDownload /> },
]);
